import TranscriptButton from './component.jsx'
export default TranscriptButton
